import cs from 'classnames';

import { ReactComponent as SendIcon } from 'assets/icons/send-1.svg';

import { useTranslation } from 'react-i18next';
import styles from './MatchesActions.module.scss';
import { getJobseekerInviteButtonText } from './utils/getJobseekerInviteButtonText';

interface MatchesActionsProps {
  applied: boolean;
  inviteSent: boolean;
  isActionDisabled: boolean;
  sendInvite: () => void;
}

const MatchesActions = ({
  applied,
  inviteSent,
  isActionDisabled,
  sendInvite
}: MatchesActionsProps) => {
  const { t } = useTranslation()
  const text = getJobseekerInviteButtonText(applied, inviteSent);
  const isDisabled = inviteSent || applied;

  const handleAction = () => {
    if (isDisabled || isActionDisabled) {
      return;
    }

    sendInvite();
  };

  return (
    <div
      className={cs(styles.wrapper, {
        [styles.disabled]: isDisabled
      })}
      onClick={handleAction}
    >
      <div className={styles.iconWrapper}>
        <SendIcon width={15} height={15} />
      </div>
      <span
        className={cs(styles.text, {
          [styles.disabled]: isDisabled
        })}
      >
        {t(text)}
      </span>
    </div>
  );
};

export default MatchesActions;
